import React from "react";
import { InlineMath } from "react-katex";
import FractionInput, { formatLatexPreview } from "../../../../components/inputs/FractionInput";

function randInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function formatMath1(v) {
  return Number(v).toFixed(1);
}

function pickData() {
  for (let i = 0; i < 800; i += 1) {
    const aUnits = randInt(0, 99); // 0,0..9,9
    const bUnits = randInt(0, 99);
    const aTenths = aUnits % 10;
    const bTenths = bUnits % 10;
    if (aTenths === 0 || bTenths === 0) continue; // bez x,0
    if (aTenths + bTenths >= 10) continue; // typ A: bez przeniesienia

    return {
      aUnits,
      bUnits,
      resultUnits: aUnits + bUnits,
      a: aUnits / 10,
      b: bUnits / 10,
      result: (aUnits + bUnits) / 10,
    };
  }

  return { aUnits: 25, bUnits: 42, resultUnits: 67, a: 2.5, b: 4.2, result: 6.7 };
}

export function generateTask() {
  return {
    type: "DecimalAdditionMemoryNoCarryTask",
    data: pickData(),
  };
}

export function renderTask({ data }) {
  return (
    <div style={{ textAlign: "left" }}>
      <p>Oblicz w pamięci: <InlineMath math={`${formatMath1(data.a)} + ${formatMath1(data.b)}`} /></p>
    </div>
  );
}

export function renderInput(_task, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
      label="wynik"
      placeholder="np. 3,2 lub 3.2"
    />
  );
}

export function checkAnswer(task, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;
  const parsed = userAnswer.parsed;
  if (parsed == null || !Number.isFinite(parsed)) return false;
  return Math.abs(parsed - task.data.result) < 1e-9;
}

export function renderAnswer({ data }) {
  return <InlineMath math={formatMath1(data.result).replace(".", "{,}")} />;
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }
  return <InlineMath math={formatLatexPreview(userAnswer.raw)} />;
}

export function renderExplanation({ data }) {
  const aWhole = Math.floor(data.aUnits / 10);
  const aTenths = data.aUnits % 10;
  const bWhole = Math.floor(data.bUnits / 10);
  const bTenths = data.bUnits % 10;

  const tenths = aTenths + bTenths;
  const whole = aWhole + bWhole;

  return (
    <div style={{ textAlign: "left" }}>
      <p>
        <strong>Krok 1:</strong> Części dziesiętne: <InlineMath math={`${aTenths}+${bTenths}=${tenths}`} />.
      </p>
      <p>
        <strong>Krok 2:</strong> Całości: <InlineMath math={`${aWhole}+${bWhole}=${whole}`} />.
      </p>
      <p>
        <strong>Wynik:</strong> <InlineMath math={`${whole}{,}${tenths}`} />.
      </p>
    </div>
  );
}

